import { render } from "./DownloadPersistencyPrintDate.vue?vue&type=template&id=8d816fce"
import script from "./DownloadPersistencyPrintDate.vue?vue&type=script&lang=js"
export * from "./DownloadPersistencyPrintDate.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__